import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-back_green",
  "use": "icon-back_green-usage",
  "viewBox": "0 0 16 12",
  "content": "<symbol viewBox=\"0 0 16 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-back_green\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.19223 0L7.3283 1.10081L3.07642 5.22149H16V6.77853H3.07642L7.3283 10.8992L6.19223 12L0 6.00001L6.19223 0Z\" fill=\"#00B259\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol